import * as actionTypes from '../../constants/actionTypes';
import { CALL_PRIVATE_API } from '../../middleware/api';
import { GET } from '../../constants/requestMethods';
import { auditLogSchema } from '../../schemas';
import { ACLQueryModeTypes } from '../../constants/visibilityFilters';

export const fetchAuditLog = (resourceType, id) => (dispatch) => {
  let resource = resourceType;
  if (resourceType === 'credentials') {
    resource = 'data_credentials';
  }
  if (resourceType === 'marketplace_domains') {
    resource = 'marketplace/domains';
  }
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_AUDIT_LOG_REQUEST,
        actionTypes.GET_AUDIT_LOG_SUCCESS,
        actionTypes.GET_AUDIT_LOG_FAILURE,
      ],
      endpoint: `/${resource}/${id}/audit_log`,
      payload: {
        expand: 1,
        interval: 'lifetime',
      },
      schema: [auditLogSchema],
      requestMethod: GET,
      //Always fetch audit log for a resource in collab mode
      aclQueryMode: ACLQueryModeTypes.MODE_COLLABORATOR.key,
      requestInfo: {
        resourceType,
        id,
      },
    },
  });
};

export const clearAuditLog = () => ({
  type: actionTypes.CLEAR_AUDIT_LOG,
});
